import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../Checkbox';

const FormCheckbox = ({
  id, title, value, setFieldValue, disabled,
}) => {
  const onToggle = () => {
    setFieldValue(id, !value);
  };

  return (
    <Checkbox
      title={title}
      name={id}
      id={id}
      onToggle={onToggle}
      checked={value}
      disabled={disabled}
    />
  );
};

FormCheckbox.defaultProps = {
  value: false,
};

FormCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  value: PropTypes.bool,
};

export default FormCheckbox;
